import { gql, useQuery } from '@apollo/client';

export const GET_GET_MEMBERS_BY_IDS = gql`
  query getMembersByIds($membersId: [ObjectId!]) {
    getMembersByIds(membersId: $membersId) {
      _id
      profile {
        displayName
      }
    }
  }
`;

export const useGetMembersByIds = ({ membersId }: { membersId?: string[] } = {}) => {
  const { data, loading } = useQuery(GET_GET_MEMBERS_BY_IDS, {
    variables: {
      membersId: membersId,
    },
    skip: !membersId,
    fetchPolicy: 'network-only',
  });

  const collection = data?.getMembersByIds || [];

  return { loading, employees: collection };
};
